import {
	requests
}from "../../../../api/agent"

export default {
	getMinOrgByNameOrUNP : (params) => requests.getWithParams('/reOrg/getMinOrgByNameOrUNP', params),
	getPaged             : (params) => requests.getWithParams('/reOrg/getPaged', params),
	create               : (params) => requests.post('/reOrg/create', params),
	update               : (params) => requests.post('/reOrg/update', params),
	delete               : (params) => requests.post('/reOrg/delete', params),
	getReOrgInfo         : (params) => requests.getWithParams('/reOrg/getReOrgInfo', params),
	updateReOrgInfo      : (params) => requests.post('/reOrg/updateReOrgInfo', params)
}